export const ERROR_REASON_CODE_MAP = {
  OTP_VERIFY_DAILY_LIMIT: '26',
}
